import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { ConfirmDialog } from './ConfirmDialog';
import { ConfirmDialogContext } from './confirmDialogsContext';
export function ConfirmDialogProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [props, setProps] = useState({});
    const { onConfirm, onCancel, ...rest } = props;
    const handleConfirm = useCallback(() => {
        setOpen(false);
        onConfirm?.();
    }, [onConfirm]);
    const handleCancel = useCallback(() => {
        setOpen(false);
        onCancel?.();
    }, [onCancel]);
    const contextValue = useMemo(() => ({ setOpen, props, setProps }), [setOpen, props, setProps]);
    return (_jsxs(ConfirmDialogContext.Provider, { value: contextValue, children: [children, _jsx(ConfirmDialog, { ...rest, open: open, onCancel: handleCancel, onConfirm: handleConfirm })] }));
}
//# sourceMappingURL=ConfirmDialogProvider.js.map